module.exports = require("ngx-bootstrap/timepicker");